module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.ed5f7c6d.webp";